import React, { Fragment } from "react";
import { styled, ThemeProvider, css } from "styled-components";
import { darken } from "polished";
import { Check, Info, Warning } from "../../icons";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const feedBackTheme = {
    error: {
        color: Colors.ALERT_ERROR,
        backgroundColor: Colors.ALERT_ERROR_LIGHT,
    },
    success: {
        color: Colors.ALERT_SUCCESS,
        backgroundColor: Colors.ALERT_SUCCESS_LIGHT,
    },
    info: {
        color: Colors.GRAY_DARKEST,
        backgroundColor: Colors.GRAY_LIGHT,
    },
    warning: {
        color: Colors.PROFILE_RED_2024,
        backgroundColor: Colors.ALERT_WARNING,
    },
};
const Text = styled.div ``;
const IconContainer = styled.div `
  padding: ${rem(16)} ${rem(16)};
  border-right: 1px solid ${({ type }) => darken(0.1, feedBackTheme[type]?.backgroundColor)};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledFeedback = styled.div `
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.color};
  display: flex;
  align-items: center;
  border-radius: ${rem(5)};

  svg {
    margin-right: ${rem(10)};
    min-width: 20px;
    min-height: 20px;
  }
  ${({ $variant }) => $variant === "notification" &&
    css `
      font-size: ${rem(16)};
      line-height: ${rem(24)};
      color: ${Colors.BLACK};
      min-height: 56px;
      background: ${({ theme }) => theme.backgroundColor};
      padding: ${rem(16)} ${rem(24)};
      svg {
        margin-right: 0;
        position: relative;
        top: 0px;
      }
      & > ${Text} {
        position: relative;
        bottom: -2px;
      }
    `}
    ${({ $variant, $showIcon }) => $variant === "notification" && $showIcon &&
    css `
        padding: 0;
        align-items: stretch;

        ${Text} {
          padding: ${rem(16)} ${rem(16)};
        }
      `}
`;
const Title = styled.strong `
  &::after {
    content: " ";
  }
`;
const iconFor = (state, size, container) => {
    switch (state) {
        case "error":
            return React.cloneElement(container, { ...container.props }, React.createElement(Warning, { width: size, height: size, color: "ALERT_ERROR" }));
        case "warning":
            return React.cloneElement(container, { ...container.props }, React.createElement(Warning, { width: size, height: size, color: "GRAY_DARKEST" }));
        case "info":
            return React.cloneElement(container, { ...container.props }, React.createElement(Info, { width: size, height: size, color: "GRAY_DARKEST" }));
        case "success":
            return React.cloneElement(container, { ...container.props }, React.createElement(Check, { width: size, height: size, color: "ALERT_SUCCESS" }));
        default:
            return null;
    }
};
export const Feedback = ({ type = "info", showIcon = true, variant = "feedback", title, children, dataCy, className, }) => (React.createElement(ThemeProvider, { theme: feedBackTheme[type] },
    React.createElement(StyledFeedback, { "$variant": variant, "$showIcon": showIcon, "data-cy": dataCy, className: className },
        showIcon && iconFor && iconFor(type, 20, variant === "notification" ? React.createElement(IconContainer, { type: type }) : React.createElement(Fragment, null)),
        React.createElement(Text, null,
            title && React.createElement(Title, null, title),
            children))));
export default Feedback;
//# sourceMappingURL=Feedback.js.map